export const SET_MEMBERSHIP_FEATURES = 'SET_MEMBERSHIP_FEATURES';
export const SET_MEMBERSHIPS = 'SET_MEMBERSHIPS';
export const SET_PLANS = 'SET_PLANS';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';